import * as axios from 'axios';

let API_URL = '';
if (process.env.NODE_ENV==='production') {
    API_URL = 'https://one.kolizey.fit/api/hs/dataapi/coachApp/v1/'
} else {
    API_URL = 'http://192.168.1.130/api/hs/dataapi/coachApp/v1/'
}

const instance = axios.create({
    baseURL: API_URL,
    headers: { 
        'content-type': 'application/json',
    }

});

export const fitAPI = {
    getInitData(token) {
        
        return instance.get(`init`, {headers: {"token":token}})
            .then(
                response => { return response.data }
            )   
    },

    getSchatdData(token, roomGuid) {
        
        return instance.get(`schatd?room=${roomGuid}`, {headers: {"token":token}})
            .then(
                response => { return response.data }
            )   
    },

    saveSchAtt(token,objData,objOldData) {
        return instance.post(`schatd`,{old:objOldData,new:objData}, {headers: {"token":token}} )
            .then(
                response => { return response.data }
            )       
    },

    getSrcPDF(token, roomGuid, d1, d2) {
        
        return instance.get(`printschatd?room=${roomGuid}&d1=${d1}&d2=${d2}`, {headers: {"token":token}, responseType: 'blob'})
            .then(
                response => { return response.data }
            )   
    },
   
}
